<template>
  <div class="resources-section">
    <div class="section-header">
      <h2 class="section-title">备课资源</h2>
      <!-- <span class="section-count">{{ completedCount }}/{{ resources.length }}</span> -->
    </div>
    
    <div class="resources-grid">
      <div 
        v-for="(resource, index) in resources" 
        :key="resource.id"
        class="resource-card"
        :class="{ clickable: status[resource.id] === 'complete' }"
        :style="{ animationDelay: `${index * 0.1}s` }"
        @click="handleResourceClick(resource)"
      >
        <div class="resource-icon-wrapper" :style="{ background: resource.color }">
          {{ resource.icon }}
          <!-- <div 
            class="status-badge" 
            :class="`status-${status[resource.id] || 'pending'}`"
          >
            {{ getStatusIcon(status[resource.id]) }}
          </div> -->
        </div>
        <div class="resource-name">{{ resource.name }}</div>
        <!-- <div class="resource-status">{{ getStatusText(status[resource.id]) }}</div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ResourceGrid',
  
  props: {
    resources: {
      type: Array,
      required: true
    },
    status: {
      type: Object,
      required: true
    }
  },
  
  computed: {
    completedCount() {
      return Object.values(this.status).filter(s => s === 'complete').length
    }
  },
  
  methods: {
    getStatusIcon(status) {
      switch(status) {
        case 'complete': return '✓'
        case 'generating': return '⚡'
        case 'pending': 
        default: return '-'
      }
    },
    
    getStatusText(status) {
      switch(status) {
        case 'complete': return '点击下载'
        case 'generating': return '生成中...'
        case 'pending': 
        default: return '等待中'
      }
    },
    
    handleResourceClick(resource) {
      if (this.status[resource.id] === 'complete') {
        this.$emit('download', resource.id)
      }
    }
  }
}
</script>

<style scoped>
.resources-section {
  margin-bottom: 24px;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.section-title {
  font-size: 24px;
  font-weight: 600;
  color: var(--text-dark);
  margin: 0;
}

.section-count {
  font-size: 14px;
  color: var(--text-light);
}

.resources-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
  gap: 20px;
}

.resource-card {
  background: var(--bg-glass);
  backdrop-filter: blur(var(--blur-md));
  -webkit-backdrop-filter: blur(var(--blur-md));
  border: 1px solid var(--border-light);
  border-radius: var(--radius-md);
  padding: 24px;
  text-align: center;
  box-shadow: var(--shadow-md);
  transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  position: relative;
  overflow: hidden;
  animation: slideUp 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
  cursor: pointer;
}

.resource-card.clickable {
  cursor: pointer;
}

.resource-card::before {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: linear-gradient(45deg, transparent, rgba(255,255,255,0.3), transparent);
  transform: rotate(45deg);
  transition: all 0.5s;
  opacity: 0;
}

.resource-card.clickable:hover::before {
  animation: shimmer 0.5s ease-out;
}

.resource-card.clickable:hover {
  transform: translateY(-6px);
  box-shadow: var(--shadow-xl);
  border-color: rgba(0, 122, 255, 0.2);
}

.resource-card:active {
  transform: translateY(0);
  box-shadow: var(--shadow-sm);
}

.resource-icon-wrapper {
  width: 64px;
  height: 64px;
  margin: 0 auto 16px;
  border-radius: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 32px;
  position: relative;
  box-shadow: var(--shadow-sm);
}

.resource-name {
  font-size: 16px;
  font-weight: 600;
  color: var(--text-dark);
  margin-bottom: 8px;
  letter-spacing: -0.01em;
}

.resource-status {
  font-size: 14px;
  color: var(--text-light);
}

.status-badge {
  position: absolute;
  bottom: -4px;
  right: -4px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  font-weight: bold;
}

.status-complete {
  color: #27ae60;
}

.status-generating {
  color: #f39c12;
  animation: pulse 1.5s infinite;
}

.status-pending {
  color: var(--text-light);
}

@media (max-width: 768px) {
  .resources-grid {
    grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
    gap: 16px;
  }
}
</style>